"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ethnicityFactory = void 0;
const Factory = require("factory.ts");
exports.ethnicityFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    code: '94',
    name: 'American Indian or Alaska Native',
});
